var _class, _MobileModalWindow;
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import classNames from "classnames";
import { runInAction } from "mobx";
import { observer } from "mobx-react";
import PropTypes from "prop-types";
import { Component } from "react";
import { withTranslation } from "react-i18next";
import Box from "../../Styled/Box";
import Icon from "../../Styled/Icon";
import DataCatalog from "../DataCatalog/DataCatalog";
import DataPreview from "../Preview/DataPreview";
import WorkbenchList from "../Workbench/WorkbenchList";
import Styles from "./mobile-modal-window.scss";
import MobileSearch from "./MobileSearch";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
let MobileModalWindow = observer(_class = (_MobileModalWindow = class MobileModalWindow extends Component {
  renderModalContent() {
    const viewState = this.props.viewState;
    const searchState = viewState.searchState;
    if (viewState.mobileView !== viewState.mobileViewOptions.data && viewState.mobileView !== viewState.mobileViewOptions.preview && searchState.showMobileLocationSearch && searchState.locationSearchText.length > 0) {
      return /*#__PURE__*/_jsx(MobileSearch, {
        terria: this.props.terria,
        viewState: this.props.viewState
      });
    }
    switch (viewState.mobileView) {
      case viewState.mobileViewOptions.data:
        // No multiple catalogue tabs in mobile
        return /*#__PURE__*/_jsx(DataCatalog, {
          terria: this.props.terria,
          viewState: this.props.viewState,
          items: this.props.terria.catalog.group.memberModels
        });
      case viewState.mobileViewOptions.preview:
        return /*#__PURE__*/_jsx(DataPreview, {
          terria: this.props.terria,
          viewState: this.props.viewState,
          previewed: this.props.viewState.previewedItem
        });
      case viewState.mobileViewOptions.nowViewing:
        return /*#__PURE__*/_jsx(WorkbenchList, {
          viewState: this.props.viewState,
          terria: this.props.terria
        });
      default:
        return null;
    }
  }
  onClearMobileUI() {
    runInAction(() => {
      this.props.viewState.switchMobileView(null);
      this.props.viewState.explorerPanelIsVisible = false;
      this.props.viewState.searchState.showMobileLocationSearch = false;
      this.props.viewState.searchState.showMobileCatalogSearch = false;
      this.props.viewState.searchState.catalogSearchText = "";
    });
  }
  UNSAFE_componentWillReceiveProps() {
    const numItems = this.props.terria.workbench.items.length;
    if ((numItems === undefined || numItems === 0) && this.props.viewState.mobileView === this.props.viewState.mobileViewOptions.nowViewing) {
      runInAction(() => {
        this.props.viewState.switchMobileView(null);
        this.props.viewState.explorerPanelIsVisible = false;
      });
    }
  }
  goBack() {
    this.props.viewState.switchMobileView(this.props.viewState.mobileViewOptions.data);
  }
  render() {
    const modalClass = classNames(Styles.mobileModal, {
      [Styles.isOpen]: this.props.viewState.explorerPanelIsVisible && this.props.viewState.mobileView
    });
    const mobileView = this.props.viewState.mobileView;
    const {
      t
    } = this.props;
    return /*#__PURE__*/_jsx("div", {
      className: modalClass,
      children: /*#__PURE__*/_jsxs(Box, {
        column: true,
        className: Styles.modalBg,
        children: [/*#__PURE__*/_jsxs("div", {
          className: Styles.modalTop,
          children: [this.props.viewState.explorerPanelIsVisible && mobileView && /*#__PURE__*/_jsx("button", {
            type: "button",
            className: Styles.doneButton,
            onClick: () => this.onClearMobileUI(),
            children: t("mobile.doneBtnText")
          }), /*#__PURE__*/_jsx("button", {
            type: "button",
            disabled: mobileView !== this.props.viewState.mobileViewOptions.preview,
            className: classNames(Styles.backButton, {
              [Styles.backButtonInactive]: mobileView !== this.props.viewState.mobileViewOptions.preview
            }),
            onClick: () => this.goBack(),
            children: /*#__PURE__*/_jsx(Icon, {
              className: Styles.iconBack,
              glyph: Icon.GLYPHS.left
            })
          })]
        }), this.renderModalContent()]
      })
    });
  }
}, _defineProperty(_MobileModalWindow, "propTypes", {
  terria: PropTypes.object,
  viewState: PropTypes.object.isRequired,
  t: PropTypes.func.isRequired
}), _MobileModalWindow)) || _class;
export default withTranslation()(MobileModalWindow);